<template bindable="heading, icon, countryicon">
  <div class="as-form-widget">
    <div class="as-form-widget__heading" if.bind="heading">
      <h6>${heading}</h6>
    </div>
    <div class="as-form-widget__main">
      <div class="as-form-widget__icon" if.bind="icon">
        <span><i class="${icon} fa-fw fa-lg"></i></span>
      </div>
      <div class="as-form-widget__icon" if.bind="countryicon">
        <span><i class="${countryicon} fa-fw"></i></span>
      </div>
      <div class="as-form-widget__content">
        <slot name="default"></slot>
      </div>
    </div>
  </div>
</template>
